import { cachePromise } from './../util/cache_promise';

export const AllTimeHitsByCountryService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON(
    $r.all_time_hits_by_country_api_v0_user_stats_path(queryParams),
  );
});

export const HitsService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON($r.hits_api_v0_user_stats_path(queryParams));
});

export const SiteSearchesService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON($r.site_searches_api_v0_user_stats_path(queryParams));
});

export const DownloadsService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON($r.downloads_api_v0_user_stats_path(queryParams));
});

export const WorksService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON($r.works_api_v0_user_stats_path(queryParams));
});

export const AllTimeHitsByRefererService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON(
    $r.all_time_referer_hit_counts_api_v0_user_stats_path(queryParams),
  );
});

export const PercentilesService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { user_id: Aedu.User.viewed.id, subdomain_param: 'api' },
    params,
  );

  return $.getJSON(
    $r.thirty_day_percentiles_api_v0_user_stats_path(queryParams),
  );
});

export const ImpactAggregationsService = cachePromise(function (params) {
  const queryParams = Object.assign(
    { subdomain_param: 'api', user_id: Aedu.User.current.id },
    params,
  );

  return $.getJSON($r.twelve_month_impact_api_v0_user_stats_path(queryParams));
});
